module.exports = __webpack_public_path__ + "videos/personalize.4323481.mp4";